/**
 * Sektör landing page verisi.
 * Her sektör için: SEO, hero, WhatsApp kaos mockup, pain point'ler, çözüm faydaları, hizmetler.
 */

export const SECTORS = [
  {
    id: 'psikolog',
    slug: 'psikolog-randevu-sistemi',
    aliasSlugs: ['psikolog-randevu'],
    title: 'Psikolog & Terapist',
    shortTitle: 'Psikologlar',
    icon: '🧠',
    colorClass: 'blue',
    gradient: 'from-blue-600 to-indigo-600',
    bgLight: 'bg-blue-50',
    textAccent: 'text-blue-600',
    borderAccent: 'border-blue-200',

    seo: {
      title: 'Psikolog Randevu Sistemi — Seans Randevularınızı Otomatikleştirin | Pine Randevu',
      description:
        'Psikolog ve terapistler için online randevu sistemi. Danışanlarınız 7/24 seans randevusu alsın, SMS hatırlatmalar ile gelmeme oranını düşürün. 15 gün ücretsiz.',
      keywords:
        'psikolog randevu sistemi, terapist randevu, online seans randevu, psikolog randevu uygulaması, seans rezervasyon, terapi randevu',
      ogImage: '/og/psikolog-randevu.svg',
    },

    hero: {
      eyebrow: 'Psikolog & Terapist iseniz',
      headline: 'Seans randevunuzu hâlâ WhatsApp\'tan mı alıyorsunuz?',
      subheadline:
        'Her gün onlarca randevu mesajını okuyup yanıtlamak yerine, danışanlarınız doğrudan kendi seans saatini seçsin. Siz sadece seansınıza odaklanın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Merhaba, bu hafta seans için müsait misiniz? 🙏' },
      { from: 'business', text: 'Merhaba, Çarşamba 14:00 müsait.' },
      { from: 'client', text: 'Çarşamba 14 olur ama saat 13 olmaz mı?' },
      { from: 'business', text: 'Maalesef 13\'te doluyum. Perşembe 15:00?' },
      { from: 'client', text: 'Perşembe müsait değilim... Cuma olur mu?' },
      { from: 'business', text: 'Cuma 10 ya da 11 müsait' },
      { from: 'client', text: 'Cuma 10 olur 👍' },
      { from: 'business', text: 'Tamam, not ettim. İsminiz?' },
    ],

    painPoints: [
      'Her randevu için 5–10 mesaj gidip geliyor, saatleriniz gidiyor',
      'Çakışan randevular, unutulan saatler, son dakika iptaller',
      'Gece 23\'te gelen "yarın randevu alabilir miyim?" mesajları',
      'Kendi terapistleri bile randevu yönetiminden yoruluyor',
    ],

    solutionBenefits: [
      'Danışanlarınız 7/24 boş saatlerinizi görüp doğrudan randevu alır',
      'Otomatik SMS hatırlatması ile gelmeme oranı %60\'a kadar düşer',
      'Online seans linkleri otomatik gönderilir',
      'Takvim çakışması sıfır — sistem hepsini yönetir',
    ],

    services: [
      'Bireysel Terapi',
      'Çift Terapisi',
      'Aile Danışmanlığı',
      'Online Seans',
      'İlk Görüşme',
      'Grup Terapisi',
    ],

    stats: [
      { value: '~3 saat', label: 'Günlük randevu mesajlaşma kaybı' },
      { value: '%60', label: 'Gelmeme oranında düşüş' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: 'Hafta sonları bile "randevu alabilir miyim?" mesajı alıyordum. Pine Randevu\'dan sonra danışanlarım sisteme giriyor, ben pazartesi gelip dolu takvimimi görüyorum.',
      name: 'Selin T.',
      role: 'Klinik Psikolog, İstanbul',
    },

    cta: 'Randevu sayfanı 5 dakikada kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'pilates',
    slug: 'pilates-randevu-sistemi',
    aliasSlugs: ['pilates-randevu'],
    title: 'Pilates & Yoga Stüdyosu',
    shortTitle: 'Pilates Stüdyoları',
    icon: '🧘',
    colorClass: 'purple',
    gradient: 'from-purple-600 to-pink-600',
    bgLight: 'bg-purple-50',
    textAccent: 'text-purple-600',
    borderAccent: 'border-purple-200',

    seo: {
      title: 'Pilates Stüdyosu Randevu Sistemi — Ders Rezervasyonunu Otomatikleştirin | Pine Randevu',
      description:
        'Pilates ve yoga stüdyoları için online ders rezervasyon sistemi. Üyeleriniz 7/24 ders seçsin, SMS hatırlatmalar ile boş yer bırakmasın. 15 gün ücretsiz.',
      keywords:
        'pilates randevu sistemi, yoga stüdyo rezervasyon, pilates ders rezervasyon, stüdyo randevu uygulaması, pilates online rezervasyon',
      ogImage: '/og/pilates-randevu.svg',
    },

    hero: {
      eyebrow: 'Pilates & Yoga Stüdyosu iseniz',
      headline: 'Ders listenizi hâlâ Excel ya da WhatsApp\'la mı yönetiyorsunuz?',
      subheadline:
        'Stüdyonuzdaki her ders saatini, her eğitmeni ayrı ayrı takip etmek yerine üyeleriniz kendi dersini seçsin. Doluluk otomatik güncellensin.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Bu hafta reformer için yer var mı?' },
      { from: 'business', text: 'Salı 18:00 ve Perşembe 19:00 var' },
      { from: 'client', text: 'Salı 18 olur. Elif hoca mı?' },
      { from: 'business', text: 'Evet Elif hoca' },
      { from: 'client', text: 'Tamam alıyorum. Hatırlatır mısınız?' },
      { from: 'business', text: 'Tabii, not ettim 👍' },
      { from: 'client', text: 'Bir de ablamı da yazmak istiyorum, yer var mı?' },
      { from: 'business', text: 'Salı 18\'de 1 yer daha var, hızlı yazın dolacak' },
    ],

    painPoints: [
      'Hangi derste kaç yer kaldığını anlık takip edemiyorsunuz',
      'Son dakika iptaller boşa gidiyor, dolduramıyorsunuz',
      'Eğitmen bazlı doluluk yönetimi karmaşaya dönüyor',
      'Üyeler "yer var mı?" diye her gün mesaj atıyor',
    ],

    solutionBenefits: [
      'Her ders ve eğitmen için ayrı kapasite takibi otomatik',
      'İptal olunca sistem listeye bildirim gönderir',
      'Üyeleriniz kendi rezervasyonunu 7/24 yapıp değiştirebilir',
      'SMS hatırlatması ile derslere gelme oranı artar',
    ],

    services: [
      'Reformer Pilates',
      'Mat Pilates',
      'Yoga Dersi',
      'Personal Pilates',
      'Grup Dersi',
      'Duvar Ünitesi',
    ],

    stats: [
      { value: '%40', label: 'Daha az iptal & no-show' },
      { value: '7/24', label: 'Üye rezervasyon imkânı' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: '"Reformer sınıflarımızın doluluk oranı %80\'den %96\'ya çıktı. Artık üyeler listeye kendileri giriyor, biz sadece ders yapıyoruz."',
      name: 'Burcu K.',
      role: 'Pilates Stüdyosu Sahibi, Ankara',
    },

    cta: 'Stüdyo rezervasyon sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'guzellik',
    slug: 'guzellik-merkezi-randevu',
    aliasSlugs: ['guzellik-salonu-randevu'],
    title: 'Kuaför & Güzellik Salonu',
    shortTitle: 'Güzellik Salonları',
    icon: '✂️',
    colorClass: 'pink',
    gradient: 'from-pink-500 to-rose-600',
    bgLight: 'bg-pink-50',
    textAccent: 'text-pink-600',
    borderAccent: 'border-pink-200',

    seo: {
      title: 'Kuaför & Güzellik Salonu Randevu Sistemi | Pine Randevu',
      description:
        'Kuaför, güzellik salonu ve nail art stüdyoları için online randevu sistemi. Müşterileriniz 7/24 randevu alsın, çakışma olmasın. 15 gün ücretsiz.',
      keywords:
        'kuaför randevu sistemi, güzellik salonu randevu, nail art randevu, berber randevu uygulaması, saç boyama randevu, online güzellik randevu',
      ogImage: '/og/guzellik-salonu-randevu.svg',
    },

    hero: {
      eyebrow: 'Kuaför & Güzellik Salonu iseniz',
      headline: 'Günde kaç kez "Cuma için yer var mı?" mesajı alıyorsunuz?',
      subheadline:
        'Müşterileriniz sizinle mesajlaşmak zorunda kalmadan, hangi saatçi müsait, hangi hizmet kaç dakika sürer — hepsini online görsün ve randevu alsın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Merhaba, cumartesi için yer var mı? 💇‍♀️' },
      { from: 'business', text: 'Hangi hizmet için?' },
      { from: 'client', text: 'Saç boyama + röfle' },
      { from: 'business', text: 'Cumartesi sabah 10\'da Zeynep müsait' },
      { from: 'client', text: 'Zeynep değil Merve\'ye gitmek istiyorum' },
      { from: 'business', text: 'Merve cumartesi dolu, pazar 11 olur mu?' },
      { from: 'client', text: 'Pazar olmaz... Bir de röfle ne kadar sürüyor?' },
      { from: 'business', text: '2-3 saat arası' },
      { from: 'client', text: 'O zaman cumartesi başka saat var mı?' },
    ],

    painPoints: [
      'Telefon ve WhatsApp mesajları arasında randevu kaybediyorsunuz',
      'Hangi saatçi, hangi saatte müsait — anlık bilmek çok zor',
      'Çakışan randevular müşteri kaybettiriyor',
      'Cumartesi günleri telefonla geçiyor, iş yapamıyorsunuz',
    ],

    solutionBenefits: [
      'Her saatçi için ayrı takvim, müşteri kime gideceğini seçer',
      'Hizmet süresi otomatik hesaplanır, çakışma imkânsız',
      'Müşteriler 7/24 kendi randevusunu alır, değiştirir, iptal eder',
      'SMS hatırlatması ile no-show oranı yarı yarıya düşer',
    ],

    services: [
      'Saç Kesimi',
      'Saç Boyama & Röfle',
      'Kalıcı Makyaj',
      'Manikür & Pedikür',
      'Cilt Bakımı',
      'Kirpik & Kaş',
    ],

    stats: [
      { value: '%50', label: 'Daha az no-show' },
      { value: '0', label: 'Randevu çakışması' },
      { value: '7/24', label: 'Online rezervasyon' },
    ],

    testimonial: {
      text: '"Müşteriler artık direkt sisteme giriyor, ben Pazar akşamı haftanın tüm doluluk durumunu görüyorum. Mükemmel."',
      name: 'Merve K.',
      role: 'Kuaför Salonu Sahibi, İstanbul',
    },

    cta: 'Salon randevu sayfanı oluştur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'test-surusu',
    slug: 'test-surusu-randevu',
    title: 'Otomotiv Bayisi & Test Sürüşü',
    shortTitle: 'Otomotiv Bayileri',
    icon: '🚗',
    colorClass: 'sky',
    gradient: 'from-sky-600 to-blue-700',
    bgLight: 'bg-sky-50',
    textAccent: 'text-sky-700',
    borderAccent: 'border-sky-200',

    seo: {
      title: 'Test Sürüşü Randevu Sistemi — Otomotiv Bayileri için Online Rezervasyon | Pine Randevu',
      description:
        'Otomotiv bayileri için test sürüşü randevu sistemi. Müşterileriniz 7/24 araç ve saat seçerek rezervasyon yapsın, SMS hatırlatma ile gelmeme oranı düşsün. 15 gün ücretsiz.',
      keywords:
        'test sürüşü randevu, otomotiv bayi randevu sistemi, araç test sürüşü rezervasyon, online test sürüşü, bayi rezervasyon sistemi',
      ogImage: '/og/oguzcan-otomotiv/og-image.jpg',
    },

    hero: {
      eyebrow: 'Otomotiv Bayisi iseniz',
      headline: 'Test sürüşü taleplerini hâlâ telefonla mı topluyorsunuz?',
      subheadline:
        'Müşterileriniz uygun araç ve saatleri online görüp rezervasyon yapsın. Satış ekibiniz arama trafiğine değil, kapatma oranına odaklansın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Merhaba, SUV modeliniz için test sürüşü almak istiyorum.' },
      { from: 'business', text: 'Tabii, hafta içi ve cumartesi müsait saatlerimiz var.' },
      { from: 'client', text: 'Cumartesi 14:00 olur mu?' },
      { from: 'business', text: '14:00 dolu, 15:30 için yerimiz var.' },
      { from: 'client', text: '15:30 uygun. Hangi belgeler gerekli?' },
      { from: 'business', text: 'Ehliyet yeterli, randevu onay SMSi gönderiyorum.' },
    ],

    painPoints: [
      'Test sürüşü talepleri telefon ve WhatsApp arasında kayboluyor',
      'Hangi araç hangi saatte müsait takibi zorlaşıyor',
      'Müşteri gelmeme oranı satış ekibinin zamanını boşa harcıyor',
      'Aynı saate çift rezervasyon riski oluşuyor',
    ],

    solutionBenefits: [
      'Müşteriler araç ve saat seçerek 7/24 online rezervasyon yapar',
      'Araç bazlı takvim ile çakışma riski ortadan kalkar',
      'Otomatik SMS hatırlatma ile no-show oranı düşer',
      'Satış ekibi günlük test sürüşü planını tek panelde görür',
    ],

    services: [
      'SUV Test Sürüşü',
      'Sedan Test Sürüşü',
      'Elektrikli Araç Deneyimi',
      'Aile Aracı Danışmanlığı',
      'Ticari Araç Deneyimi',
      'Filo Görüşmesi',
    ],

    stats: [
      { value: '%35', label: 'Daha az no-show' },
      { value: '7/24', label: 'Online test sürüşü rezervasyonu' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: '"Test sürüşü randevularını artık tek ekrandan yönetiyoruz. Satış danışmanlarımız gününü önceden planlayabiliyor."',
      name: 'Oğuzcan A.',
      role: 'Otomotiv Bayi Yöneticisi',
    },

    cta: 'Test sürüşü rezervasyon sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'dis-hekimi',
    slug: 'dis-hekimi-randevu',
    title: 'Diş Hekimi & Ağız Sağlığı',
    shortTitle: 'Diş Hekimleri',
    icon: '🦷',
    colorClass: 'teal',
    gradient: 'from-teal-500 to-cyan-600',
    bgLight: 'bg-teal-50',
    textAccent: 'text-teal-600',
    borderAccent: 'border-teal-200',

    seo: {
      title: 'Diş Hekimi Randevu Sistemi — Online Hasta Kabulünü Otomatikleştirin | Pine Randevu',
      description:
        'Diş klinikleri ve diş hekimleri için online randevu sistemi. Hastalarınız 7/24 randevu alsın, SMS hatırlatmalar ile gelmeme oranını düşürün. 15 gün ücretsiz.',
      keywords:
        'diş hekimi randevu sistemi, diş kliniği randevu, online diş hekimi randevu, hasta randevu sistemi, diş muayene randevu',
      ogImage: '/og/dis-hekimi-randevu.svg',
    },

    hero: {
      eyebrow: 'Diş Hekimi veya Klinik iseniz',
      headline: 'Sekreteriniz günün yarısını randevu almakla mı geçiriyor?',
      subheadline:
        'Hastalarınız gece yarısı diş ağrısıyla size ulaşmak istiyor. Online randevu sistemiyle hem hizmet kalitenizi hem verimliliğinizi artırın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'İyi günler, dolgu için ne zaman uygun?' },
      { from: 'business', text: 'İyi günler, Salı veya Çarşamba sabah uygun' },
      { from: 'client', text: 'Salı 10 olabilir mi?' },
      { from: 'business', text: 'Salı 10\'da Dr. Ahmet Bey müsait' },
      { from: 'client', text: 'Tamam, not edebilir misiniz?' },
      { from: 'business', text: 'Adınız soyadınız?' },
      { from: 'client', text: 'Fatma Öztürk' },
      { from: 'business', text: 'Tamam not ettik. Sigortanız var mı?' },
    ],

    painPoints: [
      'Sekreter zamanının büyük kısmı telefon ve mesajla geçiyor',
      'Hasta bilgileri WhatsApp\'ta kaybolabiliyor',
      'Tatil ve hafta sonu randevu talepleri karşılıksız kalıyor',
      'Gelmeyenleri takip etmek zaman alıyor',
    ],

    solutionBenefits: [
      'Hastalar 7/24 online randevu alır, sekreter yükü azalır',
      'Hasta bilgileri sistem üzerinde kayıtlı ve güvenli',
      'Otomatik SMS ile randevu hatırlatması, gelmeme oranı düşer',
      'Tatil günlerinde de randevu alınmaya devam eder',
    ],

    services: [
      'Muayene',
      'Diş Dolgusu',
      'Diş Beyazlatma',
      'Kanal Tedavisi',
      'İmplant Danışmanlığı',
      'Ortodonti Görüşmesi',
    ],

    stats: [
      { value: '%45', label: 'Sekreter iş yükünde azalma' },
      { value: '%55', label: 'No-show azalması' },
      { value: '7/24', label: 'Randevu erişilebilirliği' },
    ],

    testimonial: {
      text: '"Artık sekreterin telefonu meşgul değil. Hastalar gece sabah ne zaman isterlerse randevu alabiliyorlar. Geliş oranı da belirgin arttı."',
      name: 'Dr. Ayhan D.',
      role: 'Diş Hekimi, İzmir',
    },

    cta: 'Klinik randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'personal-trainer',
    slug: 'personal-trainer-randevu',
    title: 'Personal Trainer & Fitness',
    shortTitle: 'Personal Trainer\'lar',
    icon: '💪',
    colorClass: 'green',
    gradient: 'from-green-500 to-emerald-600',
    bgLight: 'bg-green-50',
    textAccent: 'text-green-600',
    borderAccent: 'border-green-200',

    seo: {
      title: 'Personal Trainer Randevu Sistemi — Antrenman Seanslarını Otomatikleştirin | Pine Randevu',
      description:
        'Personal trainer ve fitness koçları için online randevu sistemi. Müşterileriniz 7/24 antrenman saati seçsin. 15 gün ücretsiz deneyin.',
      keywords:
        'personal trainer randevu, fitness koçu randevu, antrenman randevu sistemi, PT randevu uygulaması, spor randevu',
      ogImage: '/og/personal-trainer-randevu.svg',
    },

    hero: {
      eyebrow: 'Personal Trainer veya Fitness Koçu iseniz',
      headline: 'Müşteri takibini ve seans planlamasını otomatikleştirin',
      subheadline:
        'Hangi müşteri hangi gün geliyor, kaç seans kaldı, iptal mi oldu — hepsini takip etmek yerine antrenmanlarınıza odaklanın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Bu hafta ne zaman müsaitsiniz?' },
      { from: 'business', text: 'Salı ve Perşembe sabah, Çarşamba akşam' },
      { from: 'client', text: 'Çarşamba 19:00 olur mu?' },
      { from: 'business', text: 'Çarşamba 19\'da başkası var, 20 boş' },
      { from: 'client', text: 'Tamam 20 olur. Kaç seans kaldı bende?' },
      { from: 'business', text: 'Bir saniye bakayım... 3 seans kaldı' },
      { from: 'client', text: 'Paket yenilesem indirim var mı?' },
    ],

    painPoints: [
      'Seans takibini Excel veya defterle yapmak karmaşık',
      'Müşteri iptalleri son dakika geliyor, zaman boşa gidiyor',
      'Hangi müşteride kaç seans kaldı takip etmek zaman alıyor',
      'Yeni müşteri randevuları için sürekli mesajlaşma',
    ],

    solutionBenefits: [
      'Müşteriler boş saatinizi görüp doğrudan rezervasyon yapar',
      'İptal bildirimleri anında size gelir, boşluğu hızla doldurursunuz',
      'Her müşteri için seans geçmişi sistemde kayıtlı',
      'Yeni müşteriler sizi bulup online rezervasyon yapabilir',
    ],

    services: [
      'Personal Training',
      'Beslenme Danışmanlığı',
      'Online Koçluk Seansı',
      'Grup Antrenmanı',
      'Değerlendirme Seansı',
      'Fonksiyonel Antrenman',
    ],

    stats: [
      { value: '%35', label: 'Daha az no-show' },
      { value: '2 saat', label: 'Haftalık mesajlaşma tasarrufu' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: '"Artık her hafta başında takvimim otomatik doluyor. Seans iptali olunca sistem bana bildiriyor, hemen başkasını alabiliyorum."',
      name: 'Can E.',
      role: 'Personal Trainer, İstanbul',
    },

    cta: 'Antrenman randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'dovme',
    slug: 'dovme-studyosu-randevu',
    title: 'Dövme & Piercing Stüdyosu',
    shortTitle: 'Dövme Stüdyoları',
    icon: '✒️',
    colorClass: 'slate',
    gradient: 'from-slate-700 to-gray-900',
    bgLight: 'bg-slate-50',
    textAccent: 'text-slate-700',
    borderAccent: 'border-slate-200',

    seo: {
      title: 'Dövme Stüdyosu Randevu Sistemi | Pine Randevu',
      description:
        'Dövme ve piercing stüdyoları için online randevu sistemi. Müşterileriniz 7/24 konsültasyon ve seans randevusu alsın. 15 gün ücretsiz.',
      keywords:
        'dövme stüdyosu randevu, piercing randevu, tattoo randevu sistemi, dövme konsültasyon randevu',
      ogImage: '/og/dovme-studyosu-randevu.svg',
    },

    hero: {
      eyebrow: 'Dövme & Piercing Stüdyosu iseniz',
      headline: 'DM\'leriniz randevu mesajlarıyla mı dolup taşıyor?',
      subheadline:
        'Instagram DM ve WhatsApp\'ta boğulan randevu taleplerini profesyonel bir sisteme taşıyın. Sanatçı bazlı takvim, konsültasyon randevusu, hepsi tek yerden.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Selam, küçük bir dövme için fiyat alabilir miyim?' },
      { from: 'business', text: 'Merhaba, modeli ve yerini paylaşır mısınız?' },
      { from: 'client', text: '[fotoğraf gönderdi]' },
      { from: 'business', text: 'Yaklaşık 800-1200₺ arası. Randevu almak ister misiniz?' },
      { from: 'client', text: 'Evet istiyorum, ne zaman müsaitsiniz?' },
      { from: 'business', text: 'Bu ay biraz dolu, önce konsültasyon gerekiyor' },
      { from: 'client', text: 'Konsültasyon ne zaman?' },
      { from: 'business', text: 'Haftaya Çarşamba akşam?' },
    ],

    painPoints: [
      'Instagram DM ve WhatsApp arasında randevu takibi kayboluyor',
      'Her sanatçının ayrı doluluk durumu yönetmek zor',
      'Konsültasyon + seans randevusu çift takip gerektiriyor',
      'No-show oranı yüksek, kaparo almak istiyorsunuz',
    ],

    solutionBenefits: [
      'Her sanatçı için ayrı takvim ve müsaitlik',
      'Konsültasyon ve seans ayrı hizmet olarak tanımlanabilir',
      'Müşteriler portfolyoyu görüp sanatçı seçip randevu alır',
      'Otomatik hatırlatma ile no-show oranı düşer',
    ],

    services: [
      'Dövme Konsültasyonu',
      'Dövme Yapımı',
      'Dövme Sildirme',
      'Dövme Düzeltme',
      'Piercing',
      'Dövme Bakımı',
    ],

    stats: [
      { value: '%50', label: 'Daha az no-show' },
      { value: '0', label: 'Çakışan randevu' },
      { value: '3 dk', label: 'Randevu alma süresi' },
    ],

    testimonial: {
      text: '"Stüdyomuzda 3 sanatçı var, hepsinin takvimini ayrı ayrı yönetiyorduk. Şimdi müşteriler sisteme giriyor, sanatçı seçiyor, geliyor."',
      name: 'Ali R.',
      role: 'Tattoo Artist & Stüdyo Sahibi',
    },

    cta: 'Stüdyo randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'veteriner',
    slug: 'veteriner-randevu',
    title: 'Veteriner Kliniği',
    shortTitle: 'Veterinerler',
    icon: '🐾',
    colorClass: 'amber',
    gradient: 'from-amber-500 to-orange-600',
    bgLight: 'bg-amber-50',
    textAccent: 'text-amber-600',
    borderAccent: 'border-amber-200',

    seo: {
      title: 'Veteriner Kliniği Randevu Sistemi | Pine Randevu',
      description:
        'Veteriner klinikleri için online randevu sistemi. Evcil hayvan sahipleri 7/24 muayene randevusu alsın. 15 gün ücretsiz.',
      keywords:
        'veteriner randevu sistemi, veteriner kliniği randevu, evcil hayvan randevu, online veteriner randevu, veteriner muayene randevu',
      ogImage: '/og/veteriner-randevu.svg',
    },

    hero: {
      eyebrow: 'Veteriner Kliniği iseniz',
      headline: 'Klinik telefonunuz sürekli meşgul mü?',
      subheadline:
        'Hasta sahipleri gece yarısı bile randevu almak istiyor. Online randevu sistemiyle hem acil hem rutin muayeneleri organize edin.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Merhaba, kedim için muayene randevusu alabilir miyim?' },
      { from: 'business', text: 'Merhaba, hangi günler uygun?' },
      { from: 'client', text: 'Bu hafta içinde olursa iyi olur, biraz halsiz görünüyor' },
      { from: 'business', text: 'Yarın sabah 10\'da Dr. Elif müsait' },
      { from: 'client', text: 'Yarın müsait değilim, Çarşamba olur mu?' },
      { from: 'business', text: 'Çarşamba öğleden sonra var' },
      { from: 'client', text: 'Kaçta?' },
      { from: 'business', text: '14:00 veya 15:30' },
    ],

    painPoints: [
      'Telefon meşgul, hasta sahipleri ulaşamıyor',
      'Acil ve rutin muayeneleri ayırt etmek zor',
      'Veteriner bazlı doluluk yönetimi karmaşık',
      'Aşı takip tarihleri için otomatik hatırlatma yok',
    ],

    solutionBenefits: [
      'Hasta sahipleri 7/24 online muayene randevusu alır',
      'Acil ve rutin muayene ayrı hizmet olarak tanımlanır',
      'Her veteriner için ayrı takvim yönetimi',
      'SMS hatırlatma ile randevuya geliş oranı artar',
    ],

    services: [
      'Genel Muayene',
      'Aşı',
      'Operasyon Danışmanlığı',
      'Kontrol Muayenesi',
      'Diş Temizliği',
      'Tıraş & Bakım',
    ],

    stats: [
      { value: '%40', label: 'Daha az telefon yoğunluğu' },
      { value: '7/24', label: 'Randevu erişilebilirliği' },
      { value: '%35', label: 'No-show azalması' },
    ],

    testimonial: {
      text: '"Artık sabah kliniğe geldiğimde o günün randevuları hazır. Telefonu meşgul tutmak zorunda değiliz."',
      name: 'Dr. Elif S.',
      role: 'Veteriner Hekim, Ankara',
    },

    cta: 'Klinik randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'danismanlik',
    slug: 'danismanlik-randevu',
    title: 'Danışmanlık & Koçluk',
    shortTitle: 'Danışmanlar',
    icon: '💼',
    colorClass: 'indigo',
    gradient: 'from-indigo-600 to-violet-600',
    bgLight: 'bg-indigo-50',
    textAccent: 'text-indigo-600',
    borderAccent: 'border-indigo-200',

    seo: {
      title: 'Danışmanlık & Koçluk Randevu Sistemi | Pine Randevu',
      description:
        'İş, kariyer ve yaşam koçları için online randevu sistemi. Müşterileriniz 7/24 seans randevusu alsın. 15 gün ücretsiz.',
      keywords:
        'danışmanlık randevu, koçluk randevu sistemi, iş koçu randevu, kariyer danışmanı randevu, online koçluk randevu',
      ogImage: '/og/danismanlik-randevu.svg',
    },

    hero: {
      eyebrow: 'Danışman veya Koç iseniz',
      headline: 'Danışanlarınız sizinle iletişim için ne kadar bekliyor?',
      subheadline:
        'Görüşme saatlerini e-posta, mesaj, telefon üçgeninde belirlemek yerine, danışanlarınız doğrudan takviminizdeki boş saati görsün ve rezervasyon yapsın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Merhaba, bir kariyer koçluğu seansı için görüşebilir miyiz?' },
      { from: 'business', text: 'Merhaba, tabii. Bu haftanız nasıl?' },
      { from: 'client', text: 'Çarşamba veya Perşembe uygun olur' },
      { from: 'business', text: 'Çarşamba 14:00\'te Zoom görüşmesi yapalım?' },
      { from: 'client', text: 'Çarşamba 14 biraz erken, 16 olabilir mi?' },
      { from: 'business', text: 'Çarşamba 16\'da başkası var. Perşembe 15?' },
      { from: 'client', text: 'Perşembe 15 olur. Zoom linki gönderir misiniz?' },
    ],

    painPoints: [
      'Her seans için gidip gelen mesajlarla vakit gidiyor',
      'E-posta, WhatsApp, telefon — üç kanalda takip yorucu',
      'Online görüşme linkleri son dakika gönderiliyor',
      'İptal bildirimlerini zamanında almak zor',
    ],

    solutionBenefits: [
      'Danışanlar takviminizdeki boş saati görüp direkt rezervasyon yapar',
      'Online görüşme linkleri otomatik SMS ile gönderilir',
      'İptal ve değişiklik bildirimleri anında size ulaşır',
      'Yeni danışanlar sizi online bulup randevu alabilir',
    ],

    services: [
      'Kariyer Koçluğu',
      'İş Danışmanlığı',
      'Finansal Planlama',
      'Yaşam Koçluğu',
      'Mentorluk Seansı',
      'İlk Tanışma Görüşmesi',
    ],

    stats: [
      { value: '3 saat', label: 'Haftalık mesajlaşma tasarrufu' },
      { value: '%100', label: 'Online erişilebilirlik' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: '"Danışanlarım artık takvimime bakıp kendileri saat seçiyor. Ben sadece görüşme saatinde online oluyorum."',
      name: 'Ali K.',
      role: 'Kariyer & İş Koçu',
    },

    cta: 'Danışmanlık randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'fizyoterapist',
    slug: 'fizyoterapist-randevu',
    title: 'Fizyoterapist & Fizik Tedavi',
    shortTitle: 'Fizyoterapistler',
    icon: '🦴',
    colorClass: 'cyan',
    gradient: 'from-cyan-500 to-teal-600',
    bgLight: 'bg-cyan-50',
    textAccent: 'text-cyan-600',
    borderAccent: 'border-cyan-200',

    seo: {
      title: 'Fizyoterapist Randevu Sistemi — Fizik Tedavi Seanslarını Otomatikleştirin | Pine Randevu',
      description:
        'Fizyoterapist ve fizik tedavi merkezleri için online randevu sistemi. Hastalarınız 7/24 seans randevusu alsın, SMS hatırlatmalar ile gelmeme oranını düşürün. 15 gün ücretsiz.',
      keywords:
        'fizyoterapist randevu sistemi, fizik tedavi randevu, rehabilitasyon randevu, fizyoterapi seans randevu, online fizyoterapist randevu',
      ogImage: '/og/fizyoterapist-randevu.svg',
    },

    hero: {
      eyebrow: 'Fizyoterapist veya Fizik Tedavi Merkezi iseniz',
      headline: 'Seans planlamasını hâlâ telefonla mı yapıyorsunuz?',
      subheadline:
        'Hastalarınız tedavi sürecinde düzenli seans almak istiyor. Online randevu sistemiyle hem sizi hem hastalarınızı yorulmaktan kurtarın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Merhaba, bel fıtığı için fizyoterapi almak istiyorum' },
      { from: 'business', text: 'Merhaba, ne zaman müsaitsiniz?' },
      { from: 'client', text: 'Hafta içi öğleden sonra uygun' },
      { from: 'business', text: 'Salı ve Perşembe 14:00 veya 15:00 var' },
      { from: 'client', text: 'Salı 15 olur. Kaç seans sürer genelde?' },
      { from: 'business', text: 'Duruma göre 8-12 seans, ilk değerlendirmede söyleyebilirim' },
      { from: 'client', text: 'Peki hepsi için randevu alabilir miyim şimdiden?' },
      { from: 'business', text: 'İlk gelişinizden sonra planlayalım daha sağlıklı olur' },
    ],

    painPoints: [
      'Düzenli tedavi seansları için her hafta ayrı mesajlaşma',
      'Telefon meşgul, hasta ulaşamıyor ve başka yere gidiyor',
      'Birden fazla terapist varsa takvim yönetimi karmaşık',
      'İptal bildirimleri geç geliyor, boş seans kayboluyor',
    ],

    solutionBenefits: [
      'Hastalar 7/24 müsait seansları görüp rezervasyon yapar',
      'Her terapist için ayrı takvim ve kapasite yönetimi',
      'SMS hatırlatması ile gelmeme oranı düşer, seans kaybı azalır',
      'İptal anında bildirim, boşluğu hızla doldurabilirsiniz',
    ],

    services: [
      'İlk Değerlendirme',
      'Fizik Tedavi Seansı',
      'Manuel Terapi',
      'Egzersiz Terapisi',
      'Postür Analizi',
      'Sporcu Rehabilitasyonu',
    ],

    stats: [
      { value: '%40', label: 'Daha az no-show' },
      { value: '7/24', label: 'Online randevu erişimi' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: '"Hastalarım artık düzenli seanslarını sisteme giriyor. Ben de takvimimi önceden görüp planlamalarımı yapabiliyorum."',
      name: 'Zeynep A.',
      role: 'Fizyoterapist, İstanbul',
    },

    cta: 'Fizyoterapi randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },

  {
    id: 'diyetisyen',
    slug: 'diyetisyen-randevu',
    title: 'Diyetisyen & Beslenme Uzmanı',
    shortTitle: 'Diyetisyenler',
    icon: '🥗',
    colorClass: 'lime',
    gradient: 'from-lime-500 to-green-600',
    bgLight: 'bg-lime-50',
    textAccent: 'text-lime-700',
    borderAccent: 'border-lime-200',

    seo: {
      title: 'Diyetisyen Randevu Sistemi — Beslenme Danışmanlığı Seanslarını Otomatikleştirin | Pine Randevu',
      description:
        'Diyetisyen ve beslenme uzmanları için online randevu sistemi. Danışanlarınız 7/24 seans randevusu alsın, SMS hatırlatmalar ile gelmeme oranını düşürün. 15 gün ücretsiz.',
      keywords:
        'diyetisyen randevu sistemi, beslenme uzmanı randevu, diyet danışmanlığı randevu, online diyetisyen randevu, beslenme seans randevu',
      ogImage: '/og/diyetisyen-randevu.svg',
    },

    hero: {
      eyebrow: 'Diyetisyen veya Beslenme Uzmanı iseniz',
      headline: 'Danışan takibini WhatsApp\'tan yönetmekten yoruldunuz mu?',
      subheadline:
        'Haftalık kontrol seansları, ölçüm takibi, diyet planı güncellemeleri — hepsini düzene koyun. Danışanlarınız randevusunu alsın, siz beslenme odaklı çalışın.',
    },

    whatsappMessages: [
      { from: 'client', text: 'Bu hafta kontrol için gelebilir miyim?' },
      { from: 'business', text: 'Merhaba, Çarşamba veya Cuma müsait' },
      { from: 'client', text: 'Çarşamba kaçta?' },
      { from: 'business', text: '10:00, 11:00 veya 14:00 var' },
      { from: 'client', text: '11 olur ama online da yapılıyor mu?' },
      { from: 'business', text: 'Evet online da yapabiliyoruz' },
      { from: 'client', text: 'Tamam Çarşamba 11 online olsun. Hatırlatır mısınız?' },
      { from: 'business', text: 'Not ettim, hatırlatacağım 👍' },
    ],

    painPoints: [
      'Haftalık kontrol seansları için her seferinde mesajlaşma',
      'Online ve yüz yüze seans takibini ayırt etmek zor',
      'Danışan ilerlemesini ve seans geçmişini takip etmek yorucu',
      'Gelmeme oranı yüksek, boş geçen seanslar kazanç kaybı',
    ],

    solutionBenefits: [
      'Danışanlar 7/24 haftalık kontrol seansını kendileri alır',
      'Online ve yüz yüze seans ayrı hizmet olarak tanımlanır',
      'SMS hatırlatması ile gelmeme oranı ciddi düşer',
      'Tüm seans geçmişi sistemde kayıtlı ve erişilebilir',
    ],

    services: [
      'İlk Danışmanlık Seansı',
      'Haftalık Kontrol',
      'Online Beslenme Seansı',
      'Özel Diyet Programı',
      'Spor Beslenmesi',
      'Çocuk & Ergen Beslenmesi',
    ],

    stats: [
      { value: '%45', label: 'Daha az no-show' },
      { value: '7/24', label: 'Seans rezervasyon imkânı' },
      { value: '5 dk', label: 'Kurulum süresi' },
    ],

    testimonial: {
      text: '"Danışanlarım kontrol seanslarını kendileri alıyor, ben sadece gelecek haftanın takvimini sabah bir bakıyorum. Çok daha verimli çalışıyorum."',
      name: 'Ayşe N.',
      role: 'Diyetisyen, Ankara',
    },

    cta: 'Beslenme danışmanlığı randevu sayfanı kur',
    ctaSub: 'Kredi kartı gerekmez. 15 gün ücretsiz.',
  },
];

/** slug'dan sektör bul */
export function getSectorBySlug(slug) {
  return SECTORS.find((s) => s.slug === slug || (Array.isArray(s.aliasSlugs) && s.aliasSlugs.includes(slug))) || null;
}

export function getAllSectorSlugs() {
  const all = SECTORS.flatMap((s) => [s.slug, ...(s.aliasSlugs || [])]);
  return [...new Set(all)];
}

/** Ana sayfada Solutions bileşeni için kısa liste */
export const SOLUTIONS_SECTORS = SECTORS.map(({ id, slug, title, icon, whatsappMessages, painPoints, solutionBenefits, gradient, textAccent, bgLight }) => ({
  id,
  slug,
  title,
  icon,
  whatsappMessages: whatsappMessages.slice(0, 5),
  painPoints: painPoints.slice(0, 3),
  solutionBenefits: solutionBenefits.slice(0, 3),
  gradient,
  textAccent,
  bgLight,
}));
